'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/react-fileupload-progress/~/core-js/internals/is-pure.js
// module id = 164
// module chunks = 0